import { Link } from 'react-router-dom';

export default function ArtistsDetailFooter() {
  return (
    <footer className="bg-gray-50 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-900 text-white rounded-lg">
                <i className="ri-music-2-line text-xl"></i>
              </div>
              <div>
                <div className="text-sm font-bold text-gray-900 leading-tight">日本音楽会場協会</div>
                <div className="text-xs text-gray-500">東京支部</div>
              </div>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              首都圏のライブハウスとアーティストを結び、地域の音楽文化を継続的に育てる実務組織です。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-4">サイトマップ</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/#about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  支部について
                </Link>
              </li>
              <li>
                <Link to="/#venues" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  参加会場
                </Link>
              </li>
              <li>
                <Link to="/#artists" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  登録アーティスト
                </Link>
              </li>
              <li>
                <Link to="/#schedule" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  ライブスケジュール
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-4">詳細ページ</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/venues-detail" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  参加会場一覧（詳細）
                </Link>
              </li>
              <li>
                <Link to="/artists-detail" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  登録アーティスト一覧（詳細）
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-4">お問い合わせ</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/#contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  支部窓口フォーム
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            © 2025 日本音楽会場協会 東京支部. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
